import { Button } from 'components/atoms/Button';
import { Typography } from 'components/atoms/Typography';
import { Stack } from 'components/base/layout/Stack';
import type { ToastContentProps } from 'react-toastify';

export function VersionToast({ closeToast }: ToastContentProps) {
  const handleRefresh = () => {
    closeToast(true);
    window.location.reload();
  };

  const handleDismiss = () => {
    closeToast(true);
  };

  return (
    <Stack
      gap={1.25}
      sx={{
        py: 0.25,
      }}
    >
      <Stack gap={0.5} sx={{ minWidth: 0 }}>
        <Typography
          variant="subtitle2"
          component="p"
          sx={{ fontWeight: 600, m: 0, lineHeight: 1.35 }}
        >
          A new version is available 🎉🎉
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          component="p"
          sx={{ m: 0, lineHeight: 1.45 }}
        >
          Refresh the page to load the latest changes.
        </Typography>
      </Stack>
      <Stack
        direction="row"
        gap={1}
        justifyContent="flex-end"
        alignItems="center"
        flexWrap="wrap"
      >
        <Button variant="text" size="small" onClick={handleDismiss}>
          Later
        </Button>
        <Button variant="contained" size="small" onClick={handleRefresh}>
          Refresh page
        </Button>
      </Stack>
    </Stack>
  );
}
